module.exports = __webpack_public_path__ + "img/home_icon_8.8a1edc53.png";